const state = {
    businessOperatorFlag: false,

}
const getters = {
    getBusinessOperatorFlag(state) {
        return state.businessOperatorFlag
    },
}
const mutations = {
    updateBusinessOperatorFlag(state, payload) {
        state.businessOperatorFlag = payload;
    },
}
const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}